import { render, staticRenderFns } from "./VenueImages.vue?vue&type=template&id=b8b32038&scoped=true&"
import script from "./VenueImages.vue?vue&type=script&lang=js&"
export * from "./VenueImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b32038",
  null
  
)

export default component.exports